import "./styles.css"

const LoadSpinner = ({ className, ...props }) => {
  return <span className={`loader ${className ?? ""}`} {...props}></span>
}

export default LoadSpinner
